import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  active?: boolean;
  onClick: (id) => void;
}

function NewAddressBlock({ active = false, onClick }: Props) {
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Wrapper active={active} onClick={() => onClick(null)}>
      <SvgIcon
        icon={IconType.newAddress}
        alt="Pridať adresu"
        width={24}
        height={24}
        marginRight={16}
        fill={'#000'}
      />
      <Text>{__('Pridať adresu')}</Text>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)<{ active: boolean }>`
  padding: ${rem(24)};
  border: ${({ theme, active }) =>
    active ? theme.borders.active : theme.borders.secondary};
  border-radius: ${rem(4)};
  transition: border 0.2s ease;
  max-width: ${rem(328)};
  margin-bottom: ${rem(32)};
  width: 100%;
  cursor: pointer;
  height: ${rem(176)};

  ${({ theme }) => theme.mediab.m580`
    height: ${rem(56)};
    margin-bottom: ${rem(16)};
  `}
`;

const Text = styled(TextP)`
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.primary};
`;

export { NewAddressBlock };
